export const PatternsPerPage:number = 30;
export const MaxPage:number = 99;
export const MaxOffset = PatternsPerPage * MaxPage;